// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"b390557b","453":"5c083ff3","696":"172dba61"}[chunkId] + ".chunk.js";
};